package com.rosario.juridico.repositories

import com.rosario.juridico.firebase.FirebaseWeb
import com.rosario.juridico.models.UserProfile
import dev.gitlive.firebase.firestore.*

class WebUserRepository : UserRepository {
    private val firestore get() = FirebaseWeb.firestore
    private val usersCollection get() = firestore.collection("users")

    override suspend fun getUser(uid: String): UserProfile? {
        return try {
            val doc = usersCollection.document(uid).get()
            if (doc.exists) {
                doc.data<UserProfile>()
            } else {
                null
            }
        } catch (e: Exception) {
            null
        }
    }

    override suspend fun saveUser(user: UserProfile) {
        try {
            usersCollection.document(user.uid).set(user)
        } catch (e: Exception) {
            // Error al guardar
        }
    }

    override suspend fun updatePremium(
        uid: String, 
        premium: Boolean, 
        vencimiento: Long, 
        origenPago: String,
        plan: String
    ) {
        try {
            // Actualización puntual para no reescribir todo el objeto
            usersCollection.document(uid).update(
                "premium" to premium,
                "vencimiento" to vencimiento,
                "origenPago" to origenPago,
                "plan" to plan
            )
        } catch (e: Exception) {
            // Error al actualizar
        }
    }
}
